export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const USER_DETAILS = 'USER_DETAILS';
export const DEVICE_TOKEN = 'DEVICE_TOKEN';
